/**
 * Current development environment
 * @type {boolean}
 */
export var __DEV__ = process.env.NODE_ENV !== 'production';